export const previousSearchedUsers = [];
